import { CHANGE_PASSWORD, RESET_PASSWORD } from './auth';
import actionKey from '../utils/action-key';

const DISMISS_ALERT = 'alert/DISMISS_ALERT';
const SHOW_ALERT = 'alert/SHOW_ALERT';

export default function reducer(state = null, action) {
    switch (action.type) {
        case actionKey.success(CHANGE_PASSWORD):
            return {
                title: 'Password Changed',
                type: 'success',
                button: 'Close',
            };
        case actionKey.success(RESET_PASSWORD):
            return {
                title: 'Password Reset',
                message: 'Click DONE to login to your account.',
                type: 'success',
                button: 'Done',
                link: '/',
            };
        case SHOW_ALERT:
            return {
                ...action.alert,
            };
        case DISMISS_ALERT:
            return null;
        default:
            return state;
    }
}


export const dismissAction = () => ({
    type: DISMISS_ALERT,
});

/**
 * alert
 * {
 *     title - string
 *     message - string
 *     type - success/failure
 *     button - optional
 *     link - optional
 * }
 */
export const showAlert = alert => ({
    type: SHOW_ALERT,
    alert,
});



// WEBPACK FOOTER //
// ./src/client/redux/alert.js